import { render, staticRenderFns } from "./tree-node.vue?vue&type=template&id=20b464ae&scoped=true"
import script from "./tree-node.vue?vue&type=script&lang=js"
export * from "./tree-node.vue?vue&type=script&lang=js"
import style0 from "./tree-node.vue?vue&type=style&index=0&id=20b464ae&prod&lang=less&scoped=true"
import style1 from "./tree-node.vue?vue&type=style&index=1&id=20b464ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b464ae",
  null
  
)

export default component.exports